const isFocusElsewhere = (container: HTMLElement) => {
  const activeElement = document.activeElement;
  return !!activeElement && activeElement !== document.body && !container.contains(activeElement);
};

export default isFocusElsewhere;
